import { render, staticRenderFns } from "./awardsList.vue?vue&type=template&id=d45e93a6"
import script from "./awardsList.vue?vue&type=script&lang=js"
export * from "./awardsList.vue?vue&type=script&lang=js"
import style0 from "./awardsList.vue?vue&type=style&index=0&id=d45e93a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports